import { render, staticRenderFns } from "./pos-app-bar.vue?vue&type=template&id=f984be1a&scoped=true"
import script from "./pos-app-bar.vue?vue&type=script&lang=js"
export * from "./pos-app-bar.vue?vue&type=script&lang=js"
import style0 from "./pos-app-bar.vue?vue&type=style&index=0&id=f984be1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f984be1a",
  null
  
)

export default component.exports